import { DataDetalleFirma } from "interfaces/solicitudFirma/solicitudFirmaInterface";

const typeDataSOlicitudPromocion = (
  tipoConsulta: string,
  solicitudFirma: DataDetalleFirma | null
) => {
  if (tipoConsulta === "demanda") {
    const dataSolicitud = [
      {
        id: 1,
        name: "Región",
        value: solicitudFirma?.demanda?.solicitud?.region?.NomRegion || "",
      },
      {
        id: 2,
        name: "Oficialia",
        value: solicitudFirma?.demanda?.solicitud?.oficialia?.DesJuz || "",
      },
      {
        id: 3,
        name: "Materia",
        value: solicitudFirma?.demanda?.solicitud?.materias?.descMateria || "",
      },
      {
        id: 4,
        name: "Instancia",
        value:
          solicitudFirma?.demanda?.solicitud?.instancia?.descInstancia || "",
      },
      {
        id: 5,
        name: "Via",
        value: solicitudFirma?.demanda?.via?.descModalidad || "",
      },
      {
        id: 6,
        name: "Juicio",
        value: solicitudFirma?.demanda?.liti?.descLiti || "",
      },
      {
        id: 7,
        name: "Fojas",
        value: solicitudFirma?.demanda?.solicitud?.fojas || "",
      },
      {
        id: 8,
        name: "Notas",
        value: solicitudFirma?.demanda?.solicitud?.observaciones || "",
      },
    ];
    return dataSolicitud;
  } else {
    const dataSolicitud = [
      {
        id: 1,
        name: "Juzgado",
        value:solicitudFirma?.promocion?.solicitud?.juzgado.DesJuz || "",
      }, 
      {
        id: 2,
        name: "Instancia",
        value:solicitudFirma?.promocion?.solicitud?.instancia.descInstancia || "",
      },
      {
        id: 3,
        name: "Materias",
        value:solicitudFirma?.promocion?.solicitud?.materias.descMateria || "",
      },
      {
        id: 4,
        name: "Tipo Carpeta",
        value:solicitudFirma?.promocion?.solicitud?.tipos_numeros_relaciones?.tbltiposnumero?.descTipoNumero || "",
      },
      {
        id: 5,
        name: "Fojas",
        value:solicitudFirma?.promocion?.solicitud?.noFojas || "",
      },
      {
        id: 6,
        name: "Secreto",
        value:
          solicitudFirma?.promocion?.solicitud?.secreto === "N"
            ? "No"
            : "Si" || "",
      },
      {
        id: 7,
        name: "Notas",
        value: solicitudFirma?.promocion?.solicitud?.notas || "",
      },
      {
        id: 8,
        name: "Sintesis",
        value: solicitudFirma?.promocion?.solicitud?.sintesis || "",
      },
      {
        id: 9,
        name: "Resolución",
        value: solicitudFirma?.promocion?.solicitud?.resolucion.replace(/<[^>]+>/g, '') || "",
      },
    ];

    return dataSolicitud;
  }
};

export { typeDataSOlicitudPromocion };
